module.exports = __webpack_public_path__ + "static/media/checkmarkOff_118.ddc824f2.png";